import { useEffect, useRef } from 'react';
import type { TUser } from '@/types/User.types';

const runningStates = new Set(['SANITIZING', 'REISSUING', 'REMOVING']);

export const useInvitationResolutionPolling = (users: TUser[] | undefined, refetch: () => void) => {
  const attempt = useRef(0);
  const isRunning = users?.some((user) => user.resolution && runningStates.has(user.resolution.state)) ?? false;

  useEffect(() => {
    if (!isRunning) {
      attempt.current = 0;
      return;
    }

    let timer: number;
    const poll = () => {
      timer = window.setTimeout(
        () => {
          attempt.current += 1;
          refetch();
          poll();
        },
        Math.min(3000 * 2 ** attempt.current, 30000),
      );
    };
    poll();
    return () => window.clearTimeout(timer);
  }, [isRunning, refetch]);
};
